var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MagicButton',{staticClass:"button button--shadow floating-button",class:_vm.show ? 'floating-button--show' : null,attrs:{"fab":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }